export default function ChipToggleGroup({
  options = [],
  value = [],
  onChange,
  emptyText,
  allowSelectAll = false,
  error,
}) {
  if (!options || options.length === 0) {
    return (
      <div className={`chip-group${error ? ' has-error' : ''}`}>
        <div className="chip-empty">
          {emptyText || 'No options available.'}
        </div>
      </div>
    )
  }

  const selected = new Set(value)
  const allSelected =
    options.length > 0 && options.every((o) => selected.has(o.value))

  const toggle = (v) => {
    const next = new Set(selected)
    if (next.has(v)) next.delete(v)
    else next.add(v)
    onChange(Array.from(next))
  }

  const toggleAll = () => {
    if (allSelected) onChange([])
    else onChange(options.map((o) => o.value))
  }

  const showAutoSelectAll = options.length >= 3
  const chipButtons = (
    <>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className="chip"
          aria-pressed={selected.has(o.value)}
          onClick={() => toggle(o.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') e.preventDefault()
          }}
        >
          {o.label}
        </button>
      ))}
    </>
  )

  if (showAutoSelectAll) {
    return (
      <div className={`chip-group-wrap${error ? ' has-error' : ''}`}>
        <div className="chip-group-header">
          <button
            type="button"
            className="chip-group-select-all"
            onClick={toggleAll}
          >
            {allSelected ? 'Deselect all' : 'Select all'}
          </button>
        </div>
        <div className="chip-group">
          {chipButtons}
        </div>
      </div>
    )
  }

  return (
    <div className={`chip-group${error ? ' has-error' : ''}`}>
      {allowSelectAll && (
        <button
          type="button"
          className="chip"
          aria-pressed={allSelected}
          onClick={toggleAll}
          onKeyDown={(e) => {
            if (e.key === 'Enter') e.preventDefault()
          }}
        >
          Select all
        </button>
      )}
      {chipButtons}
    </div>
  )
}
